import sanitizeHtml from 'sanitize-html'

export const SERVICE_LEVEL_FEEDBACK_MAX_DEPARTMENT_LENGTH = 200
export const SERVICE_LEVEL_FEEDBACK_MAX_AUTHOR_NAME_LENGTH = 100
export const SERVICE_LEVEL_FEEDBACK_MAX_CONTENT_LENGTH = 50000

const HTTPS_IMG_SRC_PATTERN = /<img\b[^>]*\bsrc=["']https:\/\//i

export const serviceLevelFeedbackSanitizeOptions: sanitizeHtml.IOptions = {
  allowedTags: [
    'a',
    'b',
    'br',
    'em',
    'h2',
    'h3',
    'i',
    'img',
    'p',
    'span',
    'strong',
    'u',
    'ul',
    'ol',
    'li',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel', 'style'],
    b: ['style'],
    em: ['style'],
    h2: ['style'],
    h3: ['style'],
    i: ['style'],
    img: ['src', 'alt', 'width', 'height', 'style', 'class'],
    p: ['style', 'class'],
    span: ['class', 'style'],
    strong: ['style'],
    u: ['style'],
    ul: ['style'],
    ol: ['style'],
    li: ['style'],
  },
  allowedStyles: {
    '*': {
      color: [/.*/],
      'background-color': [/.*/],
      background: [/.*/],
      'text-align': [/.*/],
    },
    img: {
      width: [/.*/],
      height: [/.*/],
      'max-width': [/.*/],
      float: [/.*/],
      display: [/.*/],
    },
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesByTag: {
    img: ['https'],
    a: ['http', 'https', 'mailto'],
  },
  transformTags: {
    a: sanitizeHtml.simpleTransform('a', {
      target: '_blank',
      rel: 'noopener noreferrer',
    }),
    img: (tagName, attribs) => {
      const src = attribs.src || ''
      if (!/^https:\/\//i.test(src)) {
        return false
      }
      return { tagName, attribs }
    },
  },
}

export const sanitizeServiceLevelFeedbackContent = (html: string): string => {
  return sanitizeHtml(html || '', serviceLevelFeedbackSanitizeOptions).trim()
}

export const stripServiceLevelFeedbackHtml = (html: string): string => {
  return sanitizeHtml(html || '', { allowedTags: [], allowedAttributes: {} }).trim()
}

/**
 * 本文にテキストまたはサニタイズ後に残る https 画像があるか
 */
export const hasServiceLevelFeedbackContent = (
  html: string,
  options?: { alreadySanitized?: boolean },
): boolean => {
  const normalized = options?.alreadySanitized
    ? html
    : sanitizeServiceLevelFeedbackContent(html)
  if (stripServiceLevelFeedbackHtml(normalized)) {
    return true
  }
  return HTTPS_IMG_SRC_PATTERN.test(normalized)
}
